export function transformError(error, message, status) {
    return {
        error,
        message,
        status,
        type: 'network_error',
    };
}
//# sourceMappingURL=oidc.api.utils.js.map